var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelegateFlip = function SvgDelegateFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 168,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#delegate-flip_svg__a)",
    d: "M81.04 50.916v83.594H204.6l-2.021 1.936-8.381 8.007-30.452 28.656-2.958 2.753h-.001c-13.747 12.832-31.79 19.809-50.324 19.809H18.571v-39.964l.124-21.523.246-28.657v-.001c.123-20.766 8.559-40.413 23.476-54.61h38.622Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#delegate-flip_svg__b)",
    strokeWidth: 0.657,
    d: "M81.04 50.916v83.594H204.6l-2.021 1.936-8.381 8.007-30.452 28.656-2.958 2.753h-.001c-13.747 12.832-31.79 19.809-50.324 19.809H18.571v-39.964l.124-21.523.246-28.657v-.001c.123-20.766 8.559-40.413 23.476-54.61h38.622Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#delegate-flip_svg__c)",
    strokeWidth: 0.657,
    d: "M81.04 50.916v83.594H204.6l-2.021 1.936-8.381 8.007-30.452 28.656-2.958 2.753h-.001c-13.747 12.832-31.79 19.809-50.324 19.809H18.571v-39.964l.124-21.523.246-28.657v-.001c.123-20.766 8.559-40.413 23.476-54.61h38.622Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#delegate-flip_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#delegate-flip_svg__e)",
    d: "M229.316-11.356v90.1c0 16.018-5.055 31.535-14.179 44.299-2.835 4.005-6.041 7.634-9.616 11.013l-.247.125h-42.165V50.713H42.162l.493-.5 33.042-31.16L87.903 7.665c13.808-13.014 30.822-19.021 49.562-19.021h91.851Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#delegate-flip_svg__f)",
    strokeWidth: 0.657,
    d: "M137.465-11.028h91.522v89.772c0 15.95-5.033 31.4-14.117 44.109l-.001.001c-2.813 3.973-5.994 7.575-9.542 10.931l-.131.067h-41.758V50.384H42.952L75.92 19.292l.001.001L88.127 7.906l.001-.001c13.741-12.952 30.672-18.933 49.337-18.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#delegate-flip_svg__g)",
    strokeWidth: 0.657,
    d: "M137.465-11.028h91.522v89.772c0 15.95-5.033 31.4-14.117 44.109l-.001.001c-2.813 3.973-5.994 7.575-9.542 10.931l-.131.067h-41.758V50.384H42.952L75.92 19.292l.001.001L88.127 7.906l.001-.001c13.741-12.952 30.672-18.933 49.337-18.933Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__a",
    x1: 27.444,
    x2: 84.027,
    y1: 9.345,
    y2: 137.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__b",
    x1: -1.472,
    x2: 32.709,
    y1: 102.664,
    y2: 63.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__c",
    x1: 29.415,
    x2: 69.515,
    y1: 162.796,
    y2: 37.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF33AF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#FF33AF",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#FF33AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FF33AF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF33AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__e",
    x1: 219.341,
    x2: 117.172,
    y1: -17.599,
    y2: 47.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__f",
    x1: 229.199,
    x2: 114.85,
    y1: 14.602,
    y2: -37.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delegate-flip_svg__g",
    x1: 139.165,
    x2: 65.547,
    y1: 42.204,
    y2: 96.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46DA93",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#46DA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DA93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "delegate-flip_svg__d",
    width: 269.754,
    height: 228.137,
    x: 0.862,
    y: -48.656,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_187_28961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_187_28961",
    result: "shape"
  })))));
};
export default SvgDelegateFlip;